import type { CreateSocietyInput, UpdateSocietyInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { createSociety, deleteSociety, updateSociety } from '../services/societies-admin.service'

export const useCreateSocietyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateSocietyInput) => await createSociety(payload),
    onSuccess: () => {
      toast.success('Sociedad creada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.societies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateSocietyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateSocietyInput }) =>
      await updateSociety(id, payload),
    onSuccess: () => {
      toast.success('Sociedad actualizada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.societies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteSocietyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteSociety(id),
    onSuccess: () => {
      toast.success('Sociedad eliminada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.societies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
